import React from 'react'

interface Props {
  currentSelectedCar: string
}

interface State {}

class CurrentCarName extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {

    }
  }

  render(): React.ReactNode {
    return(
      <div className='current-car-name-mobile'>
        {this.props.currentSelectedCar}
      </div>
    )
  }
}

export default CurrentCarName